// frontend app.js
import "./App.css";
import React, { createContext, useContext, useState } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom";
import RegistrationForm from "./components/pages/Register.js";
import ChatSelectionsPage from "./components/pages/ChatSelectionsPage.js";
import DashboardPage from "./components/pages/DashboardPage.js";
import ThankYouPage from "./components/pages/ThankYouPage.js";
import ConsentPage from "./components/pages/ConsentPage.js";

// Keeps the query string (e.g. ?pid=) when an unknown path such as
// /register?pid=ABC123 is sent to the registration page.
const RedirectHome = () => {
    const { search } = useLocation();
    return <Navigate to={{ pathname: "/", search }} replace />;
};

// Create a Context for Authentication
const AuthContext = createContext();

const App = () => {
    const [isValidDonor, setIsValidDonor] = useState(false);

    return (
        <AuthContext.Provider value={{ isValidDonor, setIsValidDonor }}>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<RegistrationForm />} />
                        <Route path="/consent" element={<ConsentPage />} />
                        <Route
                            path="/chat-selections"
                            element={
                                isValidDonor ? <ChatSelectionsPage /> : <Navigate to="/" />
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={isValidDonor ? <DashboardPage /> : <Navigate to="/" />}
                        />
                        <Route
                            path="/thank-you"
                            element={isValidDonor ? <ThankYouPage /> : <Navigate to="/" />}
                        />
                        {/* Catch-all for non-defined routes */}
                        <Route path="*" element={<RedirectHome />} />
                    </Routes>
                    {process.env.REACT_APP_VERSION && (
                        <footer className="app-version" aria-label="Application version">
                            v{process.env.REACT_APP_VERSION}{process.env.REACT_APP_COMMIT ? ` · ${process.env.REACT_APP_COMMIT}` : ""}
                        </footer>
                    )}
                </div>
            </Router>
        </AuthContext.Provider>
    );
};

// Custom hook to use auth context
export const useAuth = () => useContext(AuthContext);

export default App;
